import DgSidebarFrame from './src/main.vue'
// 为组件提供 install 安装方法，供按需引入
DgSidebarFrame.install = function (Vue) {
  Vue.component(DgSidebarFrame.name, DgSidebarFrame)
}
export default DgSidebarFrame

export { DgSidebarFrame }